import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { paragraphRegular } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import FiltersFormStyles from '@stories/Components/Misc/FiltersForm/FiltersForm.styles';
import FormStyles from '@stories/Components/Misc/Forms/Form.styles';
import styled from 'styled-components';
import SavingsProductFiltersStyles from '../SavingsProductFilters/SavingsProductFilters.styles';
const Container = styled(FiltersFormStyles.Container) ``;
const ButtonWrapper = styled(SavingsProductFiltersStyles.ButtonWrapper) `
  ${ButtonStyles.Container}[type='submit'] {
    --borderColour: ${brand.green.default};
  }
`;
const LoanToValue = styled.p `
  ${paragraphRegular};
  ${fonts.proximaNova.bold};

  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  margin: 0;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--borderColour);
`;
const Info = styled(FormStyles.Info) `
  margin: 0;
`;
const InfoButton = styled(FormStyles.InfoButton) ``;
const Tooltip = styled(FormStyles.Tooltip) ``;
const MortgagesProductFiltersStyles = {
    ButtonWrapper,
    Container,
    Info,
    InfoButton,
    LoanToValue,
    Tooltip,
};
export default MortgagesProductFiltersStyles;
